import { render, staticRenderFns } from "./TheRegroupementControls.vue?vue&type=template&id=3812460d&"
import script from "./TheRegroupementControls.vue?vue&type=script&lang=js&"
export * from "./TheRegroupementControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheRegroupementControls.vue"
export default component.exports